import { useCallback, useState } from 'react'

export const useLocalStorage = <T>(
  key: string,
  defaultValue: T,
): [T, (value: T) => void] => {
  const [storedValue, setStoredValue] = useState(() => {
    try {
      const value = localStorage.getItem(key)

      if (value) {
        return JSON.parse(value) as T
      } else {
        localStorage.setItem(key, JSON.stringify(defaultValue))

        return defaultValue
      }
    } catch (err) {
      return defaultValue
    }
  })

  const setValue = useCallback(
    (newValue: T) => {
      setStoredValue((prev) => {
        if (JSON.stringify(prev) === JSON.stringify(newValue)) return prev

        try {
          localStorage.setItem(key, JSON.stringify(newValue))
        } catch (err) {
          console.log(err)
        }

        return newValue
      })
    },
    [key],
  )

  return [storedValue, setValue]
}
